// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false, 
  urlApi: 'https://clienthub.appsqa.tenaris.com/', //'https://localhost:44308/',
  urlGraph: 'https://graph.microsoft.com/v1.0/me',
  urlLogout: 'https://www.tsqa.tenaris.com/en/',
  appInsights: {
    connectionString: 'InstrumentationKey=8aa99102-4767-45d7-a39a-46a4b88b786e;IngestionEndpoint=https://eastus2-3.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus2.livediagnostics.monitor.azure.com/;ApplicationId=710ad032-8ed3-4392-9eb0-e7b7a545f9f0', 
    instrumentationKey: '8aa99102-4767-45d7-a39a-46a4b88b786e',
    loggingLevelConsole: 0,
  },  
  feedbackTool: {
    appName: 'ClientHub', 
    url: 'https://feedback.appsqa.tenaris.com' 
  },
   auth: {
      authority: 'https://team-qa.tenaris.com/authorize',
      authWellknownEndpointUrl: 'https://team-qa.tenaris.com/.well-known/openid-configuration',
      redirectUrl: window.location.origin,
      clientId: 'EsEceE0FlMO533DybaathIhez9Cudsfn',
      scope: 'openid profile email',
      responseType: 'code',
      logout:'https://team-qa.tenaris.com/oidc/logout'
  }
};